var map = {
	"./datajson/unidad1/mod1-1.json": "2449",
	"./datajson/unidad2/carrusel.json": "82f3",
	"./glosario.json": "4607",
	"./mod9.json": "dcf0",
	"./modulos/navegacion.json": "ec32",
	"./textos_proyecto.json": "fe8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d607";